module.exports = __webpack_public_path__ + "static/img/case-1.757d67b4.png";